// TODO: Make me into a component
Billy.ContactDetailsController = Em.ObjectController.extend({
})
